// extracted by mini-css-extract-plugin
export default {"wrapper":"Archives_wrapper__mtV1S"};